import React from 'react';

import LottieAnimation from './lottie';

export default React.memo(LottieAnimation);
